import {
    SurveyItemRow,
    DivisionalManagerItemState,
} from '../pages/price-surveys/types';

export function allCompetitorPricesAreNA(row: SurveyItemRow): boolean {
    const prices = row.competitorPrices ?? {};
    const entries = Object.values(prices);
    if (entries.length === 0) return true;
    return entries.every(c => c.isNA === true);
}

export const PROPOSED_SELLING_BELOW_COST_VALIDATION_MESSAGE =
    'Proposed selling must be above cost (ex VAT) for approved items. Check highlighted cells.';

export const PROPOSED_SELLING_BELOW_COST_TOOLTIP =
    'Proposed selling price is below cost (ex VAT). You can still save; confirm this is intentional.';

export function getProposedBelowCostMessage(
    cost: number | null | undefined,
    proposed: number | null | undefined,
    vatPercent: number,
): string | null {
    if (
        proposed === undefined ||
        proposed === null ||
        !Number.isFinite(proposed) ||
        proposed <= 0
    ) {
        return null;
    }
    if (cost == null || !Number.isFinite(cost) || cost <= 0) return null;
    const proposedExVat = proposed * (100 / (100 + vatPercent));
    if (proposedExVat < cost) {
        return PROPOSED_SELLING_BELOW_COST_VALIDATION_MESSAGE;
    }
    return null;
}

export function isProposedSellingBelowCostExVat(
    cost: number | null | undefined,
    proposed: number | null | undefined,
    vatPercent: number,
): boolean {
    return getProposedBelowCostMessage(cost, proposed, vatPercent) !== null;
}

export function isBelowCostSurveySubmitMessage(
    message: string | undefined,
): boolean {
    if (!message) return false;
    return (
        message === PROPOSED_SELLING_BELOW_COST_VALIDATION_MESSAGE ||
        (message.includes('above cost') && message.includes('ex VAT'))
    );
}

export function getItemsMissingNaReason(
    surveyItems: SurveyItemRow[],
    itemStates: Map<string, DivisionalManagerItemState>,
): { labels: string[]; ids: string[] } {
    const labels: string[] = [];
    const ids: string[] = [];
    surveyItems.forEach(item => {
        if (allCompetitorPricesAreNA(item)) return;
        const state = itemStates.get(item.id);
        if (state?.isDeclinedForPriceChange && !state.declinedReason?.trim()) {
            labels.push(item.sku?.replace(/^0+/, '').trim() || item.id);
            ids.push(item.id);
        }
    });
    return { labels, ids };
}
